var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditsAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 154,
    viewBox: "0 0 123 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.099 12.4227L97.9487 2.8248C93.7111 0.381315 88.494 0.381315 84.2454 2.8248L6.87919 47.347C2.6196 49.8014 0 54.3362 0 59.2452V129.875C0 134.784 2.6196 139.308 6.86819 141.763L25.0183 151.559C29.2668 154.013 34.506 154.013 38.7546 151.559L116.132 106.827C120.38 104.373 123 99.838 123 94.94V24.3209C123 19.4119 120.38 14.8661 116.121 12.4227",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.213 26.0529C117.213 23.3012 115.067 22.2996 112.425 23.8186L38.2398 66.3705C35.5982 67.8894 33.4519 71.3455 33.4629 74.0972L33.529 141.502C33.529 144.254 35.6863 145.256 38.3169 143.737L112.502 101.174C115.144 99.6548 117.279 96.1987 117.279 93.447L117.202 26.0419L117.213 26.0529Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1953 95.6516L72.3564 104.373L91.9937 67.5938",
    stroke: "#0129FA",
    strokeWidth: 10.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1061 51.7991C62.2542 61.1175 49.4267 82.3768 49.4473 99.2959C49.4679 116.205 62.3365 122.365 78.1883 113.047C94.0402 103.729 106.868 82.4694 106.847 65.5504C106.827 48.6416 93.9579 42.4808 78.1061 51.7991",
    stroke: "#0129FA",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditsAdd);
export default __webpack_public_path__ + "static/media/creditsAdd.5060ebc578805b5ccdac68d05b065a59.svg";
export { ForwardRef as ReactComponent };